import { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Layout } from '@components/layout/Layout';
import { AnalyticsTracker } from '@components/analytics/AnalyticsTracker';
import { Home } from '@pages/Home';
import { About } from '@pages/About';
import { Donate } from '@pages/Donate';
import { Volunteer } from '@pages/Volunteer';
import { Testimonials } from '@pages/Testimonials';
import { PrivacyPolicy } from '@pages/PrivacyPolicy';
import { News } from '@pages/News';
import { Vision } from './components/sections/Vision';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  },
});

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-sky-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-sky-400 mx-auto mb-4"></div>
        <p className="text-white font-heading font-bold text-xl">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="donate" element={<Donate />} />
              <Route path="volunteer" element={<Volunteer />} />
              <Route path="vision" element={<Vision />} />
              <Route path="testimonials" element={<Testimonials />} />
              <Route path="get-involved" element={<Volunteer />} />
              <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="news" element={<News />} />
              <Route path="*" element={<div className="pt-24 pb-16"><h1 className="text-center text-4xl font-heading font-black">404 - Page Not Found</h1></div>} />
            </Route>
          </Routes>
        </Router>
      </QueryClientProvider>
    </Suspense>
  );
}

export default App;